/* src/app/stocking/system-stocking-config/system-stocking-config.component.css */
.example-h2 {
  margin: 10px;
}
.example-section {
  display: flex;
  align-content: center;
  align-items: center;
  height: 60px;
}
.example-margin {
  margin: 0 10px;
}
.mat-checkbox-inner-container {
  margin: 20px 8px auto 0 !important;
}
::ng-deep .checkbox .mdc-label {
  padding-top: 5px;
  font-size: 14px !important;
}
.example-card {
  max-width: 700px;
}
.flex-container {
  display: flex;
  flex-direction: row;
  gap: 32px;
  margin: 20px;
}
@media (max-width: 800px) {
  .flex-container {
    flex-direction: column;
  }
  ::ng-deep .mat-expansion-panel-body {
    padding: 0px !important;
  }
}
.smal-label {
  padding-top: 0px;
  margin-bottom: 0;
  padding-bottom: 0;
  font-size: 12px;
}
.expansion-panel {
  margin: 0px;
  padding: 0px;
}
/*# sourceMappingURL=system-stocking-config.component.css.map */
